import type { ScheduleModel } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const schedulesQueries = {
	list: () => ({
		queryKey: ['schedules'],
		queryFn: () => client.schedules.listSchedules(),
	}),
}
export function useSchedulesQuery<T = ScheduleModel[]>(
	options?: UseQueryOptions<ScheduleModel[], Error, T>
) {
	return useQuery<ScheduleModel[], Error, T>({
		...schedulesQueries.list(),
		...(options || {}),
	})
}
